var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29688 0.721558H10.4531L13.1094 3.33756V13.2784H3.29688V0.721558Z",
    stroke: "#222627",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92188 0.92041V3.68744H12.8594",
    stroke: "#222627",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.890625,
    y: 4.10791,
    width: 7,
    height: 7.625,
    rx: 1,
    fill: "#2C9AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49464 9.48645V7.58577C5.49464 7.41053 5.5034 7.19013 5.52092 6.92457H5.50475C5.46431 7.12543 5.43195 7.25955 5.40769 7.32695L4.63529 9.48645H4.1035L3.32099 7.34717C3.30212 7.29595 3.26909 7.15508 3.22191 6.92457H3.20371C3.22124 7.18743 3.23 7.45097 3.23 7.71518V9.48645H2.62744V6.35437H3.598L4.27335 8.24696C4.32997 8.40333 4.36838 8.55026 4.3886 8.68776H4.40276C4.44455 8.51656 4.48768 8.36828 4.53217 8.24292L5.20953 6.35437H6.15381V9.48645H5.49464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.4786798a9f00a72e71f7bb00bbe2b089.svg";
export { ForwardRef as ReactComponent };